<template>
  <div class="cart">
    <div class="heading">
      {{ $t('cart.cart') }}
      <span class="close" @click.prevent="closeCart">&#x2715;</span>
    </div>

    <div class="content">
      <div class="cart-items">
        <div
            class="cart-powerpack"
            v-for="powerpack in powerpackItems"
            :key="powerpack.build"
        >
          <div v-if="powerpack.name" class="name" v-html="powerpack.name
          .replace('V ', 'V&nbsp;')
          .replace(' bar', '&nbsp;bar')
          .replace(' liter', '&nbsp;liter')">
          </div>
          <div class="build-link"><a :href="powerpackBuildUrl(powerpack)">{{ $t('cart.backToBuild') }}</a></div>
          <div class="description" v-html="powerpack.description"></div>

          <div class="amount">
            <number-input :value="powerpack.amount" :min="0"
                          @valueChange="amountPowerpackChange($event, powerpack.build)"></number-input>
          </div>
          <div class="price">
            &euro;&nbsp;{{ (powerpack.price * powerpack.amount / 100).toFixed(2).replace('.', ',') }}
          </div>
        </div>

        <div class="cart-cilinder" v-for="(cilinder, i) in cilinderItems" :key="'cil' + cilinder.name + i">
          <div class="name" v-if="cilinder && getById[cilinder.product]"
               v-text="translate(getById[cilinder.product]['name'])"></div>
          <div class="amount">
            <number-input :value="cilinder.amount" :min="0"
                          @valueChange="amountCilinderChange($event, cilinder)"></number-input>
          </div>
          <div class="price" v-if="getById[cilinder.product]">
            &euro;&nbsp;{{
              ((getById[cilinder.product]['price'] / 100) * cilinder.amount).toFixed(2).replace('.', ',')
            }}
          </div>
        </div>

        <div class="cart-hose" v-for="(hose, i) in hoseItems" :key="'hose' + hose.title + i">
          <div class="name" v-if="hose" v-text="hose.name"></div>
          <div v-if="hose.type !== 'hose-extra'" class="build-link"><a
              :href="hoseBuildUrl(hose)">{{ $t('cart.backToBuild') }}</a></div>
          <div class="description" v-html="hose.description"></div>
          <div class="amount">
            <number-input :value="hose.amount" :min="0" @valueChange="amountHoseChange($event, hose)"></number-input>
          </div>
          <div class="price" v-if="hose.type === 'hose-extra'">
            &euro;&nbsp;{{ ((hose.price / 100) * hose.amount).toFixed(2).replace('.', ',') }}
          </div>
          <div class="price" v-else-if="hose.amount === 1">
            &euro;&nbsp;{{ ((hose.price / 100) * hose.amount).toFixed(2).replace('.', ',') }}
          </div>
          <div class="price" v-else-if="hose.amount < 5">
            &euro;&nbsp;{{ ((hose.price_2 / 100) * hose.amount).toFixed(2).replace('.', ',') }}
          </div>
          <div class="price" v-else-if="hose.amount < 10">
            &euro;&nbsp;{{ ((hose.price_5 / 100) * hose.amount).toFixed(2).replace('.', ',') }}
          </div>
          <div class="price" v-else>
            &euro;&nbsp;{{ ((hose.price_10 / 100) * hose.amount).toFixed(2).replace('.', ',') }}
          </div>
        </div>

        <div class="cart-motorconfig" v-for="(motor, i) in motorConfigItems" :key="'motor' + motor.name + i">
          <div class="name" v-if="motor && getMotorById[motor.motorId]"
               v-text="translate(getMotorById[motor.motorId]['name'])"></div>
          <div class="amount">
            <number-input :value="motor.amount" :min="0"
                          @valueChange="amountMotorConfigChange($event, motor)"></number-input>
          </div>
          <div class="price" v-if="motor && getMotorById[motor.motorId]">
            &euro;&nbsp;{{
              ((getMotorById[motor.motorId]['price'] / 100) * motor.amount).toFixed(2).replace('.', ',')
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="schema-link" v-if="powerpackItems.length || cilinderItems.length || hoseItems.length || motorConfigItems.length">
      <a href="/schema-configurator">{{ $t('cart.schema_text') }}</a>
    </div>
    <div class="cart-footer"
         v-if="powerpackItems.length || cilinderItems.length || hoseItems.length || motorConfigItems.length">
      <span class="total-price">Totaal: €&nbsp;{{ (totalPrice / 100).toFixed(2).replace('.', ',') }}</span>
      <button type="button" class="btn btn-success btn-order" @click.prevent="sendBuild">{{ $t('cart.order') }}</button>
    </div>
    <div class="notice" v-else>
      <span>{{ $t('cart.cartEmpty') }}</span>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import NumberInput from './../../input/NumberInput';

export default {
  name: "OrderCart",
  components: {
    NumberInput,
  },
  computed: {
    ...mapState({
      powerpackItems: state => state.cart.cartItems,
      cilinderItems: state => state.cart.cilinderItems.all,
      hoseItems: state => state.cart.hoseItems.all,
      motorConfigItems: state => state.cart.motorConfigItems.all,
    }),
    ...mapGetters({
      cartItems: 'cart/getAll',
      getById: 'cilinders/byId',
      getMotorById: 'motorConfigMotors/byId',
      getHoseById: 'hoses/byId',
      isMagento: 'preference/isMagento',
    }),
    totalPrice() {
      let total = 0;

      this.cilinderItems.forEach((cilinder) => {
        if (this.getById[cilinder.product]) {
          total += cilinder.amount * this.getById[cilinder.product].price;
        }
      });

      this.powerpackItems.forEach((powerpack) => {
        total += powerpack.amount * powerpack.price;
      });

      this.hoseItems.forEach((hose) => {

        let price = null;
        if (hose.type === 'hose-extra') {
          price = hose.price;
        } else if (hose.amount === 1) {
          price = hose.price;
        } else if (hose.amount < 5) {
          price = hose.price_2;
        } else if (hose.amount < 10) {
          price = hose.price_5;
        } else {
          price = hose.price_10;
        }

        total += hose.amount * price;
      });

      this.motorConfigItems.forEach((motorConfig) => {
        if (this.getMotorById[motorConfig.motorId]) {
          total += motorConfig.amount * this.getMotorById[motorConfig.motorId].price;
        }
      })

      return total;
    },
  },
  methods: {
    closeCart() {
      this.$emit('close');
    },
    amountPowerpackChange(e, id) {
      this.$store.commit('cart/setItemAmount', {build: id, newAmount: e});
    },
    amountCilinderChange(e, item) {
      this.$store.commit('cart/cilinderItems/setItemAmount', {product: item.product, newAmount: e});

      this.$store.dispatch('cart/setCartLocalStorage');
    },
    amountHoseChange(e, hose) {
      this.$store.commit('cart/hoseItems/setItemAmount', {build: hose.build, newAmount: e});

      this.$store.dispatch('cart/setCartLocalStorage');
    },
    amountMotorConfigChange(e, motorConfig) {
      this.$store.commit('cart/motorConfigItems/setItemAmount', {motorId: motorConfig.motorId, newAmount: e});

      this.$store.dispatch('cart/setCartLocalStorage');
    },
    sendBuild() {
      this.$store.dispatch('cart/sendOrder');
    },
    powerpackBuildUrl(powerpack) {
      const path = this.isMagento ? 'powerpack-generator' : 'powerpack-configurator';

      return '/' + path + '?build=' + powerpack.uid;
    },
    hoseBuildUrl(hose) {
      return '/slang-configurator?slang=' + hose.uid;
    }
  },
};
</script>

<style scoped lang="scss">
.content {
  max-height: calc(80vh - 100px);
  overflow-y: auto;
  margin-right: -20px;
  padding-right: 20px;
}

.heading {
  border-bottom: 1px #dcdcdc solid;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;

  .close {
    font-size: 20px;
    transition: all ease 0.25s;
    position: absolute;
    top: 22px;
    right: 20px;
    cursor: pointer;
    color: #a1a1a1;

    &:hover {
      color: #000;
    }
  }
}

.schema-link {
  a {
    font-weight: bold;
    color: #3DB0C7;
  }
}

.cart-items {

  .cart-cilinder,
  .cart-hose,
  .cart-powerpack,
  .cart-motorconfig {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: 1fr 1fr;
    padding: 20px 0 10px 0;
    border-bottom: 1px solid #c4c4c4;

    .name {
      max-width: 400px;
      font-size: 14px;
      grid-column: 1 / 3;
      grid-row: 1 / 2;
      font-weight: bold;
    }

    .build-link {
      font-size: 14px;
      grid-column: 1 / 3;
      grid-row: 3 / 4;

      a {
        font-weight: bold;
        color: #3DB0C7;

        &:hover {
          color: #236c7b;
        }
      }
    }

    .description {
      max-width: 400px;
      font-family: neue-haas-grotesk-text, sans-serif;
      font-size: 12px;
      grid-column: 1 / 3;
      grid-row: 4 / 5;
    }

    .amount {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
      margin-left: auto;
      font-weight: bold;
    }

    .price {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      font-weight: bold;
    }

    @media only screen and (min-width: 1000px) {
      grid-template-columns: auto 100px;
      border-bottom: unset;

      .name {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        display: flex;
        align-items: center;
        padding-right: 50px;
      }

      .build-link {
        grid-column: 1 / 3;
        grid-row: 2 / 3;
      }

      .description {
        grid-column: 1 / 2;
        grid-row: 3 / 4;
      }

      .amount {
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        display: flex;
        justify-content: flex-end;
      }

      .price {
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        text-align: right;
      }
    }
  }
}

.cart-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;

  .total-price {
    padding-right: 10px;
    font-weight: bold;
  }
}

.btn-order {
  border-radius: 35px;
  padding: 6px 40px;
  background-color: #71BC03;
  font-weight: bold;
}

.list {
  padding: 0;
  margin: 0;
  font-size: 12px;

  .item {
    padding: 8px 0;
    border-bottom: 2px solid #F0F0F0;

    .name {
      max-width: 50%;
      line-height: 1.3;
    }

    .item-header {
      display: flex;
      justify-content: space-between;
      line-height: 34px;

      .removeIcon {
        padding: 10px;
        cursor: pointer;
      }
    }

    .item-details {
      display: flex;
      flex-direction: column
    }
  }

  .btn-order {
    background-color: #3db0c7;
    color: white;
    margin: 10px auto 0 0;
    display: block;
    transition: all ease 0.2s;

    &:hover {
      background-color: darken(#3db0c7, 20%);
    }
  }

  .total-price {
    margin-top: 10px;
    display: block;
    font-size: 18px;
  }

  .item-description {
    font-weight: normal;
    font-family: neue-haas-grotesk-text, sans-serif;
  }
}

.notice {
  margin-top: 10px;
  font-family: neue-haas-grotesk-text, sans-serif;
  font-size: 12px;
}
</style>
